import DashboardTemplate from '@/components/templates/DashboardTemplate';
import { Outlet } from 'react-router-dom';

const RevenueCategoryOutlet = () => {
  return (
    <DashboardTemplate>
      <Outlet />
    </DashboardTemplate>
  );
};

export default RevenueCategoryOutlet;
